import type { ButtonProps, ButtonVariants } from "@qws-org/ui-kit";
import { Button } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { Action, HeaderSdk, Pages } from "~/core";
import { isExternalLink, isInternalLink } from "~/core/utils/action.utils";

export type HeaderButtonProps = {
  item: NonNullable<
    ExtractArrayItemType<
      NonNullable<
        NonNullable<NonNullable<HeaderSdk>["additional_menu"]>["action_items"]
      >
    >
  >["menu_action_items_id"];
  getUrl: (page: Pages) => string;
  onCallAction: (action: Action) => void;
  variant?: ButtonVariants;
} & ButtonProps<"button">;

export const HeaderButton: FC<HeaderButtonProps> = ({
  item,
  getUrl,
  onCallAction,
  ...props
}) => {
  const controlAction = item?.action;
  const action = controlAction?.action?.[0];
  let href: string | undefined;
  if (isExternalLink(action?.item)) {
    href = action.item.href ?? undefined;
  }
  if (isInternalLink(action?.item)) {
    href = action.item.page ? getUrl(action.item.page) : undefined;
  }

  return (
    <Button
      p={{ px: 12, py: 8 }}
      href={href}
      display={
        item?.action?.inactive_if?.includes("isMobile")
          ? "hidden"
          : item?.action?.inactive_if?.includes("isDesktop")
            ? "block"
            : undefined
      }
      width="100%"
      className={`  ${props.className} `}
      whiteSpace="nowrap"
      onPress={() => {
        if (controlAction) {
          onCallAction(controlAction);
        }
      }}
      size="small"
      fontWeight="mobile.bold"
      {...props}
      md={{
        p: { px: 24, py: 12 },
        display: item?.action?.inactive_if?.includes("isMobile")
          ? "block"
          : item?.action?.inactive_if?.includes("isDesktop")
            ? "hidden"
            : undefined,
        ...props.md,
      }}
    >
      {item?.translations?.[0]?.name}
    </Button>
  );
};
